/* Prepare a short entrance offscreen, then release it once. Never hide content. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var seen = new WeakSet();
  var pending = new Set();
  if (!('IntersectionObserver' in window)) return;

  function finish(element) {
    element.classList.remove('spike-reveal-pending', 'spike-reveal-running');
    pending.delete(element);
    observer.unobserve(element);
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var element = entry.target;
      observer.unobserve(element);
      // A delayed callback after a fast swipe must not animate already-visible
      // content backwards. Slow entries at the bottom get the prepared effect.
      if (reduced.matches || entry.boundingClientRect.top < window.innerHeight - 100) {
        finish(element);
        return;
      }
      element.classList.add('spike-reveal-running');
      element.addEventListener('animationend', function done(event) {
        if (event.target !== element) return;
        element.removeEventListener('animationend', done);
        finish(element);
      });
    });
  }, { threshold: 0 });

  function scan(scope) {
    if (reduced.matches) return;
    // Read first, then write: no alternating layout reads and style changes.
    var elements = Array.from(scope.querySelectorAll('.wow')).filter(function (element) {
      if (seen.has(element)) return false;
      seen.add(element);
      // Animate the outer block once instead of layering parent/child effects.
      if (element.parentElement && element.parentElement.closest('.wow')) return false;
      return element.getBoundingClientRect().top >= window.innerHeight;
    });
    elements.forEach(function (element) {
      element.classList.add('spike-reveal-pending');
      pending.add(element);
      observer.observe(element);
    });
  }
  reduced.addEventListener('change', function () {
    if (reduced.matches) pending.forEach(finish);
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    pending.forEach(function (element) { if (event.target.contains(element)) finish(element); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else scan(document);
}());
